import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function SysmeshAuth() {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    company: "",
    acceptTerms: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí irá la lógica del backend
    console.log("Form submitted:", formData);
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%)",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Red Hat Display", Roboto, "Helvetica Neue", Arial, sans-serif',
      display: "flex",
      flexDirection: "column",
    },
    header: {
      padding: "24px 80px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: "#ffffff",
      borderBottom: "1px solid #e5e5e5",
      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
    },
    logo: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#ee0000",
      letterSpacing: "-0.5px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer",
      textDecoration: "none",
    },
    logoIcon: {
      width: "36px",
      height: "36px",
      background: "linear-gradient(135deg, #ee0000 0%, #cc0000 100%)",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#ffffff",
      fontSize: "20px",
      fontWeight: "bold",
    },
    backButton: {
      padding: "10px 24px",
      background: "transparent",
      border: "1px solid #e5e5e5",
      color: "#525252",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "600",
      letterSpacing: "-0.2px",
      transition: "all 0.2s ease",
      borderRadius: "6px",
    },
    mainContent: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "60px 20px",
    },
    authContainer: {
      maxWidth: "1200px",
      width: "100%",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      background: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
      overflow: "hidden",
      border: "1px solid #e5e5e5",
    },
    leftPanel: {
      padding: "60px",
      background: "linear-gradient(135deg, #ee0000 0%, #cc0000 100%)",
      color: "#ffffff",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    leftTitle: {
      fontSize: "42px",
      fontWeight: "700",
      marginBottom: "24px",
      letterSpacing: "-1px",
      lineHeight: "1.2",
    },
    leftText: {
      fontSize: "18px",
      lineHeight: "1.7",
      marginBottom: "40px",
      opacity: 0.95,
    },
    featureList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    featureItem: {
      fontSize: "16px",
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      opacity: 0.95,
    },
    checkIcon: {
      width: "24px",
      height: "24px",
      background: "rgba(255,255,255,0.2)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      flexShrink: 0,
    },
    rightPanel: {
      padding: "60px",
    },
    formHeader: {
      marginBottom: "40px",
    },
    formTitle: {
      fontSize: "32px",
      fontWeight: "700",
      color: "#151515",
      marginBottom: "12px",
      letterSpacing: "-0.5px",
    },
    formSubtitle: {
      fontSize: "16px",
      color: "#525252",
    },
    tabButtons: {
      display: "flex",
      gap: "12px",
      marginBottom: "40px",
      background: "#f8f8f8",
      padding: "6px",
      borderRadius: "8px",
    },
    tabButton: (active) => ({
      flex: 1,
      padding: "12px 24px",
      background: active ? "#ffffff" : "transparent",
      border: "none",
      color: active ? "#151515" : "#888",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "600",
      transition: "all 0.2s ease",
      borderRadius: "6px",
      boxShadow: active ? "0 2px 4px rgba(0,0,0,0.06)" : "none",
    }),
    formContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    label: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#151515",
      letterSpacing: "-0.2px",
    },
    input: {
      padding: "14px 16px",
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      fontSize: "15px",
      color: "#151515",
      transition: "all 0.2s ease",
      fontFamily: "inherit",
      outline: "none",
    },
    checkboxGroup: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
    },
    checkbox: {
      width: "20px",
      height: "20px",
      cursor: "pointer",
      marginTop: "2px",
      accentColor: "#ee0000",
    },
    checkboxLabel: {
      fontSize: "14px",
      color: "#525252",
      lineHeight: "1.5",
      cursor: "pointer",
    },
    submitButton: {
      padding: "16px",
      background: "#ee0000",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: "0 4px 12px rgba(238, 0, 0, 0.25)",
      letterSpacing: "-0.2px",
      marginTop: "8px",
    },
    divider: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      margin: "24px 0",
    },
    dividerLine: {
      flex: 1,
      height: "1px",
      background: "#e5e5e5",
    },
    dividerText: {
      fontSize: "14px",
      color: "#888",
      fontWeight: "500",
    },
    socialButtons: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    socialButton: {
      padding: "14px",
      background: "#ffffff",
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      color: "#151515",
    },
    linkText: {
      textAlign: "center",
      fontSize: "14px",
      color: "#525252",
      marginTop: "24px",
    },
    link: {
      color: "#ee0000",
      fontWeight: "600",
      cursor: "pointer",
      textDecoration: "none",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        input:focus {
          border-color: #ee0000;
          box-shadow: 0 0 0 3px rgba(238, 0, 0, 0.1);
        }
        button:hover:not(:disabled) {
          transform: translateY(-2px);
          opacity: 0.95;
        }
        button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .social-button:hover {
          background: #f8f8f8;
          border-color: #d0d0d0;
        }
        @media (max-width: 968px) {
          .auth-container {
            grid-template-columns: 1fr !important;
          }
          .left-panel {
            display: none !important;
          }
        }
      `}</style>

      <header style={styles.header}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>SM</div>
          <span>Sysmesh</span>
        </div>
        <button style={styles.backButton}>← Volver al inicio</button>
      </header>

      <main style={styles.mainContent}>
        <div style={styles.authContainer} className="auth-container">
          <div style={styles.leftPanel} className="left-panel">
            <h2 style={styles.leftTitle}>
              {isLogin ? "Bienvenido de vuelta" : "Comienza tu prueba gratuita"}
            </h2>
            <p style={styles.leftText}>
              {isLogin
                ? "Accede a tu plataforma centralizada de gestión de infraestructura y DevOps."
                : "Únete a cientos de empresas que transformaron su infraestructura con Sysmesh."}
            </p>
            <ul style={styles.featureList}>
              <li style={styles.featureItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>30 días de prueba gratuita</span>
              </li>
              <li style={styles.featureItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>Sin tarjeta de crédito requerida</span>
              </li>
              <li style={styles.featureItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>Soporte técnico incluido</span>
              </li>
              <li style={styles.featureItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>Configuración en menos de 5 minutos</span>
              </li>
            </ul>
          </div>

          <div style={styles.rightPanel}>
            <div style={styles.formHeader}>
              <h1 style={styles.formTitle}>
                {isLogin ? "Iniciar Sesión" : "Crear Cuenta"}
              </h1>
              <p style={styles.formSubtitle}>
                {isLogin
                  ? "Ingresa tus credenciales para continuar"
                  : "Completa los datos para comenzar"}
              </p>
            </div>

            <div style={styles.tabButtons}>
              <button
                style={styles.tabButton(isLogin)}
                onClick={() => setIsLogin(true)}
              >
                Iniciar Sesión
              </button>
              <button
                style={styles.tabButton(!isLogin)}
                onClick={() => setIsLogin(false)}
              >
                Registrarse
              </button>
            </div>

            <div style={styles.formContainer}>
              {!isLogin && (
                <>
                  <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="fullName">
                      Nombre Completo
                    </label>
                    <input
                      style={styles.input}
                      type="text"
                      id="fullName"
                      name="fullName"
                      placeholder="Juan Pérez"
                      value={formData.fullName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="company">
                      Empresa
                    </label>
                    <input
                      style={styles.input}
                      type="text"
                      id="company"
                      name="company"
                      placeholder="Tu Empresa S.A."
                      value={formData.company}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              )}

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="email">
                  Email Corporativo
                </label>
                <input
                  style={styles.input}
                  type="email"
                  id="email"
                  name="email"
                  placeholder="tu@empresa.com"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="password">
                  Contraseña
                </label>
                <input
                  style={styles.input}
                  type="password"
                  id="password"
                  name="password"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleInputChange}
                />
              </div>

              {!isLogin && (
                <div style={styles.formGroup}>
                  <label style={styles.label} htmlFor="confirmPassword">
                    Confirmar Contraseña
                  </label>
                  <input
                    style={styles.input}
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="••••••••"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                  />
                </div>
              )}

              {isLogin ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={styles.checkboxGroup}>
                    <input
                      style={styles.checkbox}
                      type="checkbox"
                      id="remember"
                      name="remember"
                    />
                    <label style={styles.checkboxLabel} htmlFor="remember">
                      Recordarme
                    </label>
                  </div>
                  <Link
                    style={{ ...styles.link, fontSize: "14px" }}
                    href="/forgot-password"
                  >
                    ¿Olvidaste tu contraseña?
                  </Link>
                </div>
              ) : (
                <div style={styles.checkboxGroup}>
                  <input
                    style={styles.checkbox}
                    type="checkbox"
                    id="acceptTerms"
                    name="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleInputChange}
                  />
                  <label style={styles.checkboxLabel} htmlFor="acceptTerms">
                    Acepto los{" "}
                    <Link style={styles.link} href="/tyc">
                      Términos y Condiciones
                    </Link>{" "}
                    y la{" "}
                    <Link style={styles.link} href="/privacy">
                      Política de Privacidad
                    </Link>
                  </label>
                </div>
              )}

              <button style={styles.submitButton} onClick={handleSubmit}>
                {isLogin ? "Iniciar Sesión" : "Crear Cuenta"}
              </button>
            </div>

            <div style={styles.divider}>
              <div style={styles.dividerLine}></div>
              <span style={styles.dividerText}>O continúa con</span>
              <div style={styles.dividerLine}></div>
            </div>

            <div style={styles.socialButtons}>
              <button
                style={styles.socialButton}
                className="social-button"
                type="button"
              >
                <span>🔷</span> Google
              </button>
              <button
                style={styles.socialButton}
                className="social-button"
                type="button"
              >
                <span>💼</span> Microsoft
              </button>
            </div>

            <p style={styles.linkText}>
              {isLogin ? (
                <>
                  ¿No tienes cuenta?{" "}
                  <Link
                    to="/register"
                    style={styles.link}
                    onClick={() => setIsLogin(false)}
                  >
                    Regístrate gratis
                  </Link>
                </>
              ) : (
                <>
                  ¿Ya tienes cuenta?{" "}
                  <Link
                    to="/login"
                    style={styles.link}
                    onClick={() => setIsLogin(true)}
                  >
                    Inicia sesión
                  </Link>
                </>
              )}
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
